<template lang="pug">
  div.legend__group
    div.legend__type
      label.legend__switch.switch
        span.semibold.legend__name Операторы
        input.visually-hidden.switch__input(type="checkbox" @change="getOperators" v-model="checked")
        span.switch__block
</template>

<script>
import { map } from '@/api/api-endpoints'

export default {
  name: 'map-operators',
  data: () => ({
    checked: false,
    data: null,
  }),
  methods: {
    async getOperators() {
      this.$store.commit('preloaderStart')
      if (this.checked) {
        this.data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: map.transport(),
          })
        ).data
        this.$store.commit('preloaderEnd')
      } else {
        this.data = []
      }
      this.$emit('setOperators', this.data)
    },
  },
}
</script>
